import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {InfoIcon} from 'shells/icon/svg/info-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

type Props = {
    isEditingValue: boolean;
};

export function LeadValueInfo(props: Props) {
    if (!props.isEditingValue) {
        return null;
    }

    return (
        <div className='px-16'>
            <Stack isHorizontal={true} spacing={4} alignItems='center'>
                <InfoIcon
                    size={16}
                    wrapWithDiv={false}
                    // @ts-expect-error
                    color={colors.greyLt}
                    useCurrentColor={true}
                />
                <Body color='light' size='small'>
                    This change overrides the value set by products
                </Body>
            </Stack>
        </div>
    );
}
